import { render, staticRenderFns } from "./ModalLogout.vue?vue&type=template&id=553171f8&scoped=true&"
import script from "./ModalLogout.vue?vue&type=script&lang=js&"
export * from "./ModalLogout.vue?vue&type=script&lang=js&"
import style0 from "./ModalLogout.vue?vue&type=style&index=0&id=553171f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553171f8",
  null
  
)

export default component.exports